import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const SearchMagnifyOn: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9891 29.3181C23.1823 29.3181 29.0134 23.487 29.0134 16.2938C29.0134 9.10071 23.1823 3.26953 15.9891 3.26953C8.79602 3.26953 2.96484 9.10071 2.96484 16.2938C2.96484 23.487 8.79602 29.3181 15.9891 29.3181Z"
      fill="white"
    />
    <path
      d="M29.1105 24.323C30.8732 21.4831 31.7545 17.9577 31.2649 14.2365C30.2856 7.28374 24.7038 1.79974 17.8489 0.918443C7.86034 -0.256757 -0.561361 8.16504 0.613739 18.1535C1.49504 25.0084 6.97904 30.5903 13.8339 31.4716C17.5551 31.9612 21.0805 31.0799 23.9204 29.3172L33.3214 38.1306C35.5737 40.3829 39.4908 38.8161 39.4908 35.5845C39.4908 34.6052 39.0991 33.7239 38.4136 33.0384L29.1105 24.323ZM15.9883 29.2193C8.83964 29.2193 2.96404 23.3437 2.96404 16.195C2.96404 9.04634 8.74174 3.26864 15.9883 3.26864C23.2349 3.26864 29.0126 9.14424 29.0126 16.2929C29.0126 23.4416 23.137 29.2193 15.9883 29.2193Z"
      fill="#002677"
    />
    <path
      d="M6.66948 16.1934C6.61918 16.1934 6.56788 16.1905 6.51668 16.1841C5.83118 16.1006 5.34378 15.4771 5.42728 14.792C5.97708 10.2891 9.47758 6.57421 13.9395 5.75781C14.6187 5.63041 15.2696 6.08301 15.3941 6.76221C15.5186 7.44141 15.0684 8.09281 14.3897 8.21681C10.9922 8.83841 8.32718 11.6665 7.90868 15.0947C7.83158 15.7286 7.29248 16.1934 6.66948 16.1934Z"
      fill="#FF612B"
    />
  </Box>
)
export default SearchMagnifyOn
